import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Inbox, LogOut, Users, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/tabs';
import { adminMe, auth } from '../lib/api';
import RichiesteTab from './admin/RichiesteTab';
import UtentiTab from './admin/UtentiTab';

const AdminPanel = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('richieste');
  const [me, setMe] = useState(null);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    adminMe()
      .then(setMe)
      .catch(() => {
        auth.clear();
        navigate('/admin/login', { replace: true });
      });
  }, [navigate]);

  const handleLogout = () => {
    auth.clear();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <header className="bg-slate-900 text-white shadow border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-11 h-11 rounded-xl bg-white/10 ring-1 ring-white/10 flex items-center justify-center shrink-0">
              <img src="/logo-white.png" alt="RS Igienizzazione Canali" className="h-7 w-auto object-contain" />
            </div>
            <div className="leading-tight min-w-0">
              <div className="font-semibold truncate">Admin — RS Igienizzazione Canali</div>
              <div className="text-xs text-slate-400 truncate">
                {me ? `Utente: ${me.username}` : 'Pannello di controllo'}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center h-9 px-3 rounded-md text-sm text-white/90 hover:text-white bg-white/5 hover:bg-white/10 ring-1 ring-white/10 transition-colors"
              title="Apri il sito pubblico in una nuova scheda"
            >
              <ExternalLink className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">Vai al sito</span>
            </a>
            <Button variant="ghost" onClick={handleLogout} className="text-white hover:bg-white/10">
              <LogOut className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">Esci</span>
            </Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Tabs value={tab} onValueChange={setTab} className="mb-6">
          <TabsList>
            <TabsTrigger value="richieste">
              <Inbox className="w-4 h-4 mr-2" />
              Richieste
              {unread > 0 && (
                <span className="ml-2 text-xs bg-sky-500 text-white px-2 py-0.5 rounded-full">{unread}</span>
              )}
            </TabsTrigger>
            <TabsTrigger value="utenti">
              <Users className="w-4 h-4 mr-2" />
              Utenti
            </TabsTrigger>
          </TabsList>
        </Tabs>

        {tab === 'richieste' && <RichiesteTab onUnreadChange={setUnread} />}
        {tab === 'utenti' && <UtentiTab currentUsername={me?.username} />}
      </div>
    </div>
  );
};

export default AdminPanel;
